import { gql } from "@apollo/client"

export const GET_ORG_CLASSES = gql`
  query getOrgClasses($data: GetOrgClassesRequest) {
    getOrgClasses(data: $data) {
      classes {
        id
        schoolName
        className
        teacherName
        grades
        period
        subject
        courseCode
        eocSubjects
        createdAt
        createdBy
        studentCount
        meta {
          managedByIntegration
        }
      }
      meta {
        canAddClass
        availableEocSubjects
        page
        pageSize
        hasNextPage
        hasPrevPage
      }
    }
  }
`

export const DOWNLOAD_ORG_CLASSES = gql`
  query downloadOrgClasses($data: DownloadOrgClassesRequest) {
    downloadOrgClasses(data: $data) {
      status
      url
    }
  }
`

export const GET_CLASS = gql`
  query getClass($id: String!, $orgRefScope: OrgRefScope!) {
    getClass(id: $id, orgRefScope: $orgRefScope) {
      id
      className
      teacherId
      districtId
      schoolId
      grades
      period
      subject
      courseCode
      eocSubjects
    }
  }
`
